import { webOnly } from './webOnly'

// Keyboard focus ring for web, empty on native.
//
// Declared explicitly because two layers strip the browser default on web:
// react-native-web zeroes the outline on every pressable, and the host CSS reset
// zeroes it again on focused buttons. A `focus-visible:` utility outranks both.
//
// Platform selection lives here in JS, so the utilities stay plain. Why the gate
// and not a `web:` prefix: NativeWind's selector compiler understands only the
// pseudo-classes hover, active, focus, disabled and empty
// (react-native-css-interop `normalize-selectors`), so a `focus-visible:` rule
// reaches the native runtime with an EMPTY condition set — and an empty set
// passes. `web:` would also work now that AOS-995 registers that variant for web
// builds (`webVariantPlugin`), but this gate is explicit, unit-testable, and
// verified on both web and the iOS simulator; don't swap mechanisms casually.
//
// Measured on iOS: RN does not actually render the outline style props there, so
// an ungated ring showed nothing rather than a permanent outline. The gate stays
// as protection for the day RN/NativeWind do honour them (Android unverified).
//
// `focus-visible` (not `focus`) keeps mouse presses ringless. All four utilities
// are needed: in Tailwind 3 the width alone leaves the outline style unset.
// Colour is the per-tenant `action.focus-ring` token.
export const WEB_FOCUS_RING_CLASS =
    'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-action-focus-ring'

export const FOCUS_RING_CLASS = webOnly(WEB_FOCUS_RING_CLASS)
